// eslint-disable-next-line import/no-cycle
import {
  ConfigurationPanelStructure,
  ConfigurationPanelStructureItemEnum,
  TemplateStructureEnum,
  TabItem, LinkTypeEnum,
  ComponentNameEnum,
  RichTextingCTAActionTypeEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import { setAttribute, setContent, setRichTextingCTAItems } from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName, getContent, getRichTextingCta, isAttributeActive, isVisible, isSmartListExclusionVisible,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getDisplayFieldConfig from '@/components/template-builder/config/fields/display-config';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import getTextareaVariablesFieldConfig from '@/components/template-builder/config/fields/textarea-variables-config';
// eslint-disable-next-line import/no-cycle
import imageFieldConfig from '@/components/template-builder/config/fields/image-config';

// eslint-disable-next-line import/no-cycle
import getDropdownFieldConfig from '@/components/template-builder/config/fields/dropdown-config';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import selectionTypeConfig from '@/components/template-builder/config/fields/selection-type-config';
// eslint-disable-next-line import/no-cycle
import getItemListFieldConfig from '@/components/template-builder/config/fields/item-list-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import { OperatorType } from '@/types/generated-types/graphql';
// eslint-disable-next-line import/no-cycle
import { UserState } from '@/composables/User';
// eslint-disable-next-line import/no-cycle
import {
  getRcsSmartListDisplayedElements,
  getRcsSmartListProperty,
  isRcsSmartListManualSelection,
  isRcsSmartListEnabled,
  hasMoreThanOneRcsCta,
} from '@/components/template-builder/getters/rcs-smart-product-list';
// eslint-disable-next-line import/no-cycle
import {
  setRcsSmartListDisplayedElements,
  setRcsSmartListProperty,
  refreshRcsSmartlist,
} from '@/components/template-builder/setters/rcs-smart-product-list';

const ctaTypeOptions = [
  LinkTypeEnum.WEB_ADDRESS,
  LinkTypeEnum.CALL_NUMBER,
  LinkTypeEnum.QUICK_REPLY,
];

// RCS has no variable position restrictions (unlike WhatsApp which requires Meta template validation)

export const pageTabItemConfig: TabItem = {
  type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
  tabItemType: TemplateStructureEnum.PAGE,
  label: 'templateBuilder.configs.richTexting',
  tabPanel: {
    label: 'templateBuilder.configs.richTexting',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.richTextingContent',
        selector: 'body div#spm_body',
        items: [
          {
            label: 'templateBuilder.fields.richTextingImage',
            selector: '{SELECTOR} img.rcs-message__image',
            properties: [
              { name: 'data-show-image', getter: isAttributeActive, setters: [setAttribute] },
              { name: 'src', getter: getAttributeByName, setters: [setAttribute] },
            ],
            ...imageFieldConfig,
            displayToggle: true,
            fieldId: 'richTextingImage',
            enableValue: 'true',
            disableHandler: () => isRcsSmartListEnabled(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledBySmartList',
            options: {
              ...imageFieldConfig.options,
              remove: true,
              isSrcUrl: true,
            },
          },
          {
            label: 'templateBuilder.fields.richTextingMediaHeight',
            selector: '{SELECTOR} img.rcs-message__image',
            properties: [
              { name: 'data-media-height', getter: getAttributeByName, setters: [setAttribute] },
            ],
            ...getDropdownFieldConfig(
              [
                { value: 'short', label: 'templateBuilder.fields.mediaHeight.short' },
                { value: 'medium', label: 'templateBuilder.fields.mediaHeight.medium' },
                { value: 'tall', label: 'templateBuilder.fields.mediaHeight.tall' },
              ],
              'tall',
            ),
            displayToggle: false,
            parentFieldId: 'richTextingImage',
            isVisible,
            disableHandler: () => isRcsSmartListEnabled(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledBySmartList',
          },
          {
            label: 'templateBuilder.fields.richTextingTitle',
            selector: '{SELECTOR} .rcs-message__title',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getInputVariablesFieldConfig('', variables.allVariables, false, true),
            options: {
              ...getInputVariablesFieldConfig('', variables.allVariables, false, true).options,
              maxLength: 200,
              required: true,
              requiredErrorKey: 'templateBuilder.validation.rcs.titleRequired',
            },
            displayToggle: false,
            parentFieldId: 'richTextingImage',
            isVisible,
            disableHandler: () => isRcsSmartListEnabled(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledBySmartList',
          },
          {
            label: 'templateBuilder.fields.richTextingMessage',
            selector: '{SELECTOR} .rcs-message__text',
            properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
            ...getTextareaVariablesFieldConfig('Texte de la notification', variables.allVariables, true),
            options: {
              ...getTextareaVariablesFieldConfig('Texte de la notification', variables.allVariables, true).options,
              maxLength: 2000,
              required: true,
              requiredErrorKey: 'templateBuilder.validation.rcs.contentRequired',
            },
            disableHandler: () => isRcsSmartListEnabled(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledBySmartList',
          },
          {
            label: 'templateBuilder.fields.richTextingCtas',
            selector: '{SELECTOR} .rcs-message__cta.rcs-message__cta__list',
            properties: [
              {
                name: 'content',
                getter: getRichTextingCta,
                setters: [setRichTextingCTAItems],
              },
            ],
            componentName: ComponentNameEnum.RICHTEXTING_CTAS,
            options: {
              ctaTypeOptions,
              variablesList: variables.allVariables,
              actionTypes: [{ label: 'templateBuilder.configs.richTextingCtaOptions.openlink', value: RichTextingCTAActionTypeEnum.OPEN_LINK }],
              hideEmailSubject: true,
              hideEmailBody: true,
              ctaMaxLength: 25,
            },
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.smartListConfiguration',
        selector: 'body div#spm_body',
        defaultOpen: true,
        items: [
          {
            label: 'templateBuilder.fields.enableSmartList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'enabled',
              getter: getRcsSmartListProperty,
              setters: [setRcsSmartListProperty],
            }],
            ...getDisplayFieldConfig('enabled', 'false', 'false', 'true'),
            displayToggle: false,
            fieldId: 'enableSmartList',
            enableValue: 'true',
            disableHandler: () => hasMoreThanOneRcsCta(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledByMultipleCtas',
          },
          {
            label: 'templateBuilder.fields.selectionType',
            selector: '{SELECTOR}',
            properties: [
              {
                name: 'engine',
                getter: getRcsSmartListProperty,
                setters: [setRcsSmartListProperty],
                callbacks: [refreshRcsSmartlist],
              },
              {
                name: 'nb_weeks',
                getter: getRcsSmartListProperty,
                setters: [setRcsSmartListProperty],
                callbacks: [refreshRcsSmartlist],
              },
              {
                name: 'ids',
                getter: getRcsSmartListProperty,
                setters: [setRcsSmartListProperty],
                callbacks: [refreshRcsSmartlist],
              },
            ],
            ...selectionTypeConfig,
            parentFieldId: 'enableSmartList',
            isVisible,
          },
          {
            label: 'templateBuilder.fields.productList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'excluded_ids',
              getter: getRcsSmartListProperty,
              setters: [setRcsSmartListProperty],
              callbacks: [refreshRcsSmartlist],
            }],
            ...getItemListFieldConfig(
              [],
              'ShopsProducts',
              { id: 'id_shop_product', label: 'name', elementId: 'id_product' },
              'templateBuilder.fields.excludeProducts',
              [
                { field: 'lang', value: UserState.user.lang ?? 'fr', operator: OperatorType.Equals },
                { field: 'active', value: true, operator: OperatorType.Equals },
              ],
            ),
            parentFieldId: 'enableSmartList',
            isVisible: isSmartListExclusionVisible,
          },
          {
            label: 'templateBuilder.fields.categoryList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'excluded_categories',
              getter: getRcsSmartListProperty,
              setters: [setRcsSmartListProperty],
              callbacks: [refreshRcsSmartlist],
            }],
            ...getItemListFieldConfig(
              [],
              'ShopsProductsCategoriesList',
              { id: 'id_shop_product_category_list', label: 'name', elementId: 'id_category' },
              'templateBuilder.fields.excludeCategories',
              [
                { field: 'lang', value: UserState.user.lang ?? 'fr', operator: OperatorType.Equals },
              ],
            ),
            parentFieldId: 'enableSmartList',
            isVisible: isSmartListExclusionVisible,
          },
          {
            label: 'templateBuilder.fields.manufacturerList',
            selector: '{SELECTOR}',
            properties: [{
              name: 'excluded_manufacturers',
              getter: getRcsSmartListProperty,
              setters: [setRcsSmartListProperty],
              callbacks: [refreshRcsSmartlist],
            }],
            ...getItemListFieldConfig(
              [],
              'ShopsManufacturers',
              { id: 'id_manufacturer', label: 'name', elementId: 'id_manufacturer' },
              'templateBuilder.fields.excludeManufacturers',
              [],
            ),
            parentFieldId: 'enableSmartList',
            isVisible: isSmartListExclusionVisible,
          },
          {
            label: 'templateBuilder.fields.maxDisplayedProducts',
            selector: '{SELECTOR}',
            disableHandler: () => isRcsSmartListManualSelection(),
            disableMessage: 'templateBuilder.fields.warningMessages.disabledByManualSelection',
            properties: [{
              name: 'nb',
              getter: getRcsSmartListProperty,
              setters: [setRcsSmartListProperty],
              callbacks: [refreshRcsSmartlist],
            }],
            ...getStepperFieldConfig(),
            parentFieldId: 'enableSmartList',
            displayToggle: false,
            isVisible,
          },
          {
            label: 'templateBuilder.fields.displayedElements',
            selector: '{SELECTOR}',
            properties: [
              {
                name: 'displayedElements',
                getter: getRcsSmartListDisplayedElements,
                setters: [setRcsSmartListDisplayedElements],
                callbacks: [refreshRcsSmartlist],
              },
            ],
            componentName: ComponentNameEnum.MULTIDROPDOWN,
            options: {
              list: [
                { label: 'templateBuilder.fields.productTitle', value: 'spm_product_list_element_title' },
                { label: 'templateBuilder.fields.price', value: 'spm_product_list_element_price' },
                { label: 'templateBuilder.fields.description', value: 'spm_product_list_element_description' },
                { label: 'templateBuilder.fields.image', value: 'spm_product_list_element_image' },
              ],
              defaultValue: [],
              mandatoryFields: ['spm_product_list_element_title', 'spm_product_list_element_image'],
            },
            parentFieldId: 'enableSmartList',
            isVisible,
          },
          {
            label: 'templateBuilder.fields.buttonText',
            selector: '#spm_body .rcs-smartlist-carousel',
            properties: [{
              name: 'buttonText',
              getter: getRcsSmartListProperty,
              setters: [setRcsSmartListProperty],
            }],
            ...getInputVariablesFieldConfig('Texte du bouton', variables.allVariables, false, false),
            options: {
              ...getInputVariablesFieldConfig('Texte du bouton', variables.allVariables, false, false).options,
              maxLength: 25,
              required: true,
              requiredErrorKey: 'templateBuilder.validation.rcs.ctaTextRequired',
            },
            parentFieldId: 'enableSmartList',
            isVisible,
          },
        ],
      },
    ],
  },
};

const pageItemConfig: ConfigurationPanelStructure = {
  items: [
    pageTabItemConfig,
  ],
};

export default pageItemConfig;
